import React, { useState, useEffect, useRef } from "react";
import { sbaAxios } from "../../utils/sbaAxios";
import { TopBar } from "../../shared/topBar/TopBar";
import { BreadCrumbs } from "../../shared/breadCrumbs/BreadCrumbs";
import { UrlPath } from "../../../config/routeConfig";
import { DateRangePicker } from "rsuite";
import moment from "moment";
import { SBAComboBox } from "../../UiComponents/SBADropDown";
import { Modal } from "react-bootstrap";
import { AgGridReact } from "ag-grid-react";
import { getServerDetails}from "../../../config/apiConfig";
export const ServerInfo = () => {
    const [render, setRender] = useState(true);
    const [serverdata, setServerData] = useState(emptyServerData);
    let Level = [{ BreadCrumb: "Admin > ", Routes: `${UrlPath.Admin}` }];

    Level = render ? Level : [...Level, { BreadCrumb: `Server Info`, Routes: `${UrlPath.Classfications}`,},]
    useEffect(() => {
        document.title = `Server Info`;
        setRender(false);
        GetServerDetails();
    }, []);   
        const GetServerDetails = () => {
            sbaAxios({ url: `${getServerDetails}` })
            .then((res) => {
               
                setServerData(res);
            })
            .catch((error) => {
                console.error("Error fetching server details", error);
            });
    };
    return (
        <>
            <div className="">
              <div className="bg-white p-3 border rounded">      
                    <table>
                        <tbody>
                            <tr >
                                <td className="p-4">Client Name : </td>
                                <td className="p-4">{process.env.REACT_APP_NEXTGEN_CLIENT_NAME}</td>
                            </tr>
                            <tr>

                            </tr>
                            <tr >
                                <td className="p-4">Server Name : </td>
                                <td className="p-4">{serverdata?.ServerName}</td>
                            </tr>
                            <tr>
                                <td className="p-4">Server Ip Address : </td>
                                <td className="p-4">{serverdata?.ServerIpAddress}</td>
                            </tr>
                            <tr>
                                <td className="p-4">Database Server Name : </td>
                                <td className="p-4">{serverdata?.DatabaseServerName}</td>
                            </tr>
                            <tr>
                                <td className="p-4">API URL : </td>
                                <td className="p-4">{process.env.REACT_APP_NEXTGEN_URL}</td>
                            </tr>
                            <tr>
                                <td className="p-4">Swagger : </td>
                                <td className="p-4">{serverdata.swagger?"On":"Off"}</td>
                            </tr>
                            <tr>
                                <td className="p-4">Dev Mode : </td>
                                <td className="p-4">{serverdata.devMode?"On":"Off"}</td>
                            </tr>
                        </tbody>
                    </table>
                          
                      </div>
                  </div>
                 
        </>
      );
}
const emptyServerData = {
    ClientName: null,
    ServerName: '',
    ServerIpAddress: [],
    DatabaseName: '',
    ApiUrl: null,
    DatabaseServerName:''
};
